import React, { useState } from "react";
import * as yup from "yup";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import { Principal } from "@dfinity/agent";
import { toast } from "react-toastify";
import CardContent from "@origyn-sa/common-ui/src/components/atoms/CardContent";
import { H2, H3 } from "@origyn-sa/common-ui/src/components/atoms/H/H.styled";
import Form from "@origyn-sa/common-ui/src/components/templates/Form";
import InputField from "@origyn-sa/common-ui/src/components/molecules/InputField";
import Button from "@origyn-sa/common-ui/src/components/atoms/Button";
import { fetchPaymentMethods } from "../../utils";
import Select from "@origyn-sa/common-ui/src/components/molecules/Select";
import Label from "@origyn-sa/common-ui/src/components/atoms/Label";
import { client } from "../../agent";
import { LinearProgress } from "@material-ui/core";

export interface IPaymentMethodModal {
  open: boolean;
  onClose: () => void;
}

const schema = yup.object().shape({
  canisterId: yup.string().required(),
});

const PaymentMethodModal = ({ open, onClose }: IPaymentMethodModal) => {
  const [errors, setErrors]: [{ [key: string]: string }, any] = useState({});
  const [loader, setLoader] = useState<boolean>(false);
  const handleFormChange = async (data: any) => {
    console.debug({ data });
    try {
      setLoader(true);
      await client.actor.addPaymentMethod({
        _principal: Principal.fromText(data.canisterId),
        kind: { icpStandardKind: null },
        enabled: true,
      });
      fetchPaymentMethods();
      toast.success("Payment method added");
      onClose();
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLoader(false);
    }
  };

  const handleValidation = (data: any) => {
    setErrors(data);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      {loader && <LinearProgress style={{ width: "100%", top: 0, left: 0 }} />}
      <CardContent textAlign='center' padding='40px 55px'>
        <Grid container justify='center' spacing={1}>
          <Grid item>
            <H3 spacing={[0, 3]}>Add a new payment method</H3>
          </Grid>
        </Grid>
        <Form
          onSubmit={handleFormChange}
          schema={schema}
          onValidation={handleValidation}
        >
          <Grid container>
            <Grid item xs={12}>
              <Label>Payment type</Label>
              <Select
                small={false}
                isDisabled
                defaultValue={{
                  label: "ICP Ledger Standard",
                  value: "icpStandardKind",
                }}
                // onChange={()}
                options={[
                  { label: "ICP Ledger Standard", value: "icpStandardKind" },
                  {
                    label: "ORIGYN v1 FT Standard",
                    value: "origynFTv1StandardKind",
                  },
                ]}
              />
              <br />
              <InputField
                required
                error={errors.canister}
                label="Canister's Principal"
                name='canisterId'
                defaultValue={`ryjl3-tyaaa-aaaaa-aaaba-cai`}
                placeholder='Principal (aaaaa-....)'
              />
            </Grid>
          </Grid>
          <Button disabled={loader} type='submit' spacing={2}>
            Add
          </Button>
        </Form>
      </CardContent>
    </Dialog>
  );
};

export default PaymentMethodModal;
